module.exports = __webpack_public_path__ + "img/13.1920fbba.svg";